import { chatReducer } from './chatReducer';
import { journalReducer } from './journalReducer';
import { ehrReducer } from './ehrReducer';
import { healthReducer } from './healthReducer';
import { calendarReducer } from './calendarReducer';
import { forYouReducer } from './forYouReducer';
import { uiReducer } from './uiReducer';
import type { AppState, AppAction } from '../appReducerTypes';

/**
 * Combined app reducer composed from domain slices.
 * Each reducer returns the full state; unchanged when it doesn't handle the action.
 */
export function appReducer(state: AppState, action: AppAction): AppState {
  const s1 = chatReducer(state, action);
  const s2 = journalReducer(s1, action);
  const s3 = ehrReducer(s2, action);
  const s4 = healthReducer(s3, action);
  const s5 = calendarReducer(s4, action);
  const s6 = forYouReducer(s5, action);
  return uiReducer(s6, action);
}

export { chatReducer, journalReducer, ehrReducer, healthReducer, calendarReducer, forYouReducer, uiReducer };
